import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaymentModel } from '../components/card-detail/card-detail.component';
import { appApiUrl } from '@app/configs/app-api-urls.config';
import { RenewSubscriptionRequest } from '@app/shared/models/subscription-renewal.model';


@Injectable()
export class StripePaymentService {

  private basePath = 'stripe/';
  public planId: string;
  public accessToken: string;
  public _userType: Number;
  public currentPlan: any;

  constructor(
    private _http: HttpClient) {
  }

  private authHeaders(argAccessToken): any {
    const headersConfig: any = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (argAccessToken) {
      headersConfig.Authorization = `Bearer ${argAccessToken}`;
    }
    return headersConfig;
  }

  //Subscription Plans

  subscriptionPlans(argAccessToken): Observable<any> {
    const headersConfig: any = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (argAccessToken) {
      headersConfig.Authorization = `Bearer ${argAccessToken}`;
    }
    return this._http.get<any>(`${this.basePath}subscription-plans`, { headers: headersConfig });
  }

  //Subscription Plans

  payment(argPaymentModel: PaymentModel, argAccessToken): Observable<any> {
    const headersConfig: any = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (argAccessToken) {
      headersConfig.Authorization = `Bearer ${argAccessToken}`;
    }

    return this._http.post<PaymentModel>(`${this.basePath}payment`, argPaymentModel, { headers: headersConfig });
  }

  renewSubscription(argRequest: RenewSubscriptionRequest, argAccessToken): Observable<any> {
    return this._http.post<any>(appApiUrl.stripe.renewSubscription, argRequest, {
      headers: this.authHeaders(argAccessToken)
    });
  }

  setAutoRenew(enabled: boolean, argAccessToken): Observable<any> {
    return this._http.post<any>(appApiUrl.stripe.autoRenew, { enabled }, {
      headers: this.authHeaders(argAccessToken)
    });
  }

  getSavedCard(argAccessToken): Observable<any> {
    return this._http.get<any>(appApiUrl.stripe.customerCard, {
      headers: this.authHeaders(argAccessToken)
    });
  }

  /** Replaces the saved card with the one behind a Stripe token; nothing is charged. */
  updateCard(tokenId: string, argAccessToken): Observable<any> {
    return this._http.post<any>(appApiUrl.stripe.updateCard, { tokenId }, {
      headers: this.authHeaders(argAccessToken)
    });
  }

  getLastPayment(argAccessToken): Observable<any> {
    return this._http.get<any>(appApiUrl.stripe.lastPayment, {
      headers: this.authHeaders(argAccessToken)
    });
  }
}
